import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { constantvalues } from "../../../const";
import { environment } from "../../environments/environment.development";
import { DtoModule, ModuleDetails } from "../../../models/package-center.model";

@Injectable({
    providedIn: 'root'
})

export class ModuleService {
    baseURL: string;
    constructor(private httpClient: HttpClient) {
        this.baseURL = environment.gatewayUrl;
    }

    getAllModules(sectorId: number, payload: any) {
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.GET_ALL_MODULES}/${sectorId}`, {params: payload});
    }

    getSubCategoriesForModules(sectorId: number, payload: DtoModule | any) {
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.GET_ALL_SUBCATEGORIES}/${sectorId}`, payload);
    }

    createModule(moduleDetails: ModuleDetails) {
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.CRUD_MODULE}`, moduleDetails);
    }

    updateModule(moduleDetails: ModuleDetails) {
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.CRUD_MODULE}`, moduleDetails);
    }

    deleteModule(moduleId: number) {
        return this.httpClient.delete(`${this.baseURL}${constantvalues.API_URL.CRUD_MODULE}`, {
            params: {
                moduleId: moduleId
            }
        });
    }

    updateModuleStatus(moduleId: number) {
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.CRUD_MODULE}/${moduleId}`, null);
    }
}